import React, { useState } from 'react'
import { Form, Input, Button } from 'antd';

const EmailInput = (props) => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [form] = Form.useForm();

    const inputStyle = {marginBottom: '0'}

    const handleSubmit = (e) => {
        e.preventDefault()
        form.validateFields()
        .then(values => {
            setIsSubmitting(true);
            props.handleSubmit(email)
            setIsSubmitting(false);
        })
        .catch(errorInfo => {
            console.log(errorInfo)
        });
    }

    const emailChange = ({ target: { value } }) => {
        setEmail(value);
    }

    return (
        <Form form={form} layout='vertical'>
            <Form.Item
                name="email"
                label="Email"
                style={inputStyle}
                rules={[
                    {
                        required: true,
                        message: 'Email is required',
                    },
                ]}
            >
                <Input 
                    className={props.className}
                    placeholder="jdoe2@example.com" 
                    type="email"
                    onChange={emailChange}
                />
            </Form.Item>
            <Form.Item style={inputStyle} >
                <Button block type="primary" htmlType="submit" disabled={(isSubmitting)} onClick={handleSubmit}>{props.buttonText}</Button>
            </Form.Item>
        </Form>
    );
}

export default EmailInput;